import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { provideClientHydration, withNoIncrementalHydration } from '@angular/platform-browser';
import { routes } from './app.routes';
import { SeoGuard } from './guards/seo.guard';

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes, withComponentInputBinding()), provideClientHydration(withNoIncrementalHydration()), SeoGuard]
};
